import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  SvgIcon,
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Logo from 'src/components/Logo';
import Account from './Account';
import Search from './Search';
import background from '../../../assets/topbar-rectangle.jpg';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    boxShadow: 'none',
    backgroundImage: `url(${background})`,
  },
  toolbar: {
    minHeight: 64
  },
  centerLogo: {
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'absolute',
    left: 0,
    right: 0,
    width: '128px',
    height: '60px',
    zIndex: 10
  },
  logoTextBox: {
    marginLeft: theme.spacing(1)
  },
  logoTextBig: {
    fontSize: '17px',
    fontFamily: 'Montserrat',
    fontWeight: 'bold',
    lineHeight: 1
  },
  logoTextSmall: {
    fontSize: '14px',
    fontFamily: 'Montserrat',
    fontWeight: 'bold',
    lineHeight: 1
  }
}));

function TopBar({
  className,
  onMobileNavOpen,
  ...rest
}) {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      {...rest}
    >
      <RouterLink className={classes.centerLogo} to="/">
        <Logo />
      </RouterLink>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        <Search />
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
